import React, { useState } from 'react';
import Icon from '@ant-design/icons';
import { Menu } from 'antd';
import DotSvg from '@icons/dot.svg';
import styles from './styles/Shortcuts.less';
import { calcShortcutInterval } from '@utils';
import { DATE_SHORTCUTS } from '@utils/constants';

const Shortcuts = (props) => {
  const { shortcuts, selected, onChange, live } = props;
  const defaultIntervalForCustom = calcShortcutInterval(DATE_SHORTCUTS.last6Hours);
  const [previousSelectedInterval, setPreviousSelectedInterval] =
    useState(defaultIntervalForCustom);
  const onMenuSelect = ({ key, item }) => {
    const selectedInterval = item.props.interval;
    setPreviousSelectedInterval(selectedInterval);
    onChange(selectedInterval, key);
  };

  const elements = shortcuts.map(([shortcut, interval]) => {
    return (
      <Menu.Item key={shortcut} interval={interval} id={`date-picker-${shortcut}`.toLowerCase()}>
        {shortcut === DATE_SHORTCUTS.last15Mins ? (
          <div className={styles.rtshortcut}>
            <div className={styles.liveModeMarker} />
            {shortcut}
          </div>
        ) : (
          shortcut
        )}
      </Menu.Item>
    );
  });
  return (
    <Menu selectedKeys={[selected]} className={styles.shortcuts} onClick={onMenuSelect}>
      {live ? (
        <Menu.Item key="live" id="date-picker-live">
          <div className={styles.rtshortcut}>
            <div className={styles.liveModeMarker} />
            {'Live'}
          </div>
        </Menu.Item>
      ) : null}
      {elements}
      <Menu.Item key="custom" id="date-picker-custom" interval={previousSelectedInterval}>
        Custom
      </Menu.Item>
    </Menu>
  );
};

Shortcuts.defaultProps = {
  selected: 'custom',
  live: false,
};

export default Shortcuts;
